/**
 * @summary     app.ui.requiredFieldsCheck.js
 * @description Required fields and data validation logical component
 * @version     1.1
 > 1.0 Initial version
 - 03/18/2016 CG
 > 1.1 Tweaks to validation logic
 - 03/23/2016 SG
 ** EXAMPLES:
 ** NOTE:
 ** TODO:
 */

// eslint-disable-next-line prefer-arrow-callback
app.ui.addFeature('requiredFieldsCheck', function () {
  const validationFunc = (currentValue, fld, operation, logics) => {
    const currentLabel = $(`#label-${fld.attr('id')}`).html();
    const isTime = fld.hasClass('timePicker');
    const isDate = fld.hasClass('date-field');
    const typeMap = {
      mustBeGreater: '>',
      mustBeLess: '<',
      mustBeEqual: '===',
      mustNotBeEqual: '!==',
    };
    let returnObj = {
      raw: currentValue,
      formatted: currentValue,
      alwaysEnforceValidation: true,
      message: '',
      isValid: true,
    };

    // loop thru logic[] and loop thru rules[] under each logic
    if (logics) {
      logics.forEach((logic) => {
        if (logic.rules) {
          logic.rules.forEach((rule) => {
            const { comparedWithDomId, idOverride, valueAction, value, isValueTypeInput } = rule;
            if (valueAction !== typeMap[operation]) {
              app.ui.modal.error(
                'Something is wrong, please check the validation logic for this field or talk to the Admin'
              );
            } else if (comparedWithDomId || idOverride || value.toString()) {
              let thisValue = currentValue;
              let compareValue = isValueTypeInput
                ? value.toString()
                : $(`#${comparedWithDomId}`).val() || $(`#${idOverride}`).val();
              let thisName = currentLabel;

              if (thisValue && isTime) {
                thisValue = Date.parse(`01-01-0000${thisValue}`);
              }

              if (compareValue && $(`#${comparedWithDomId}`).hasClass('timePicker')) {
                compareValue = Date.parse(`01-01-0000${compareValue}`);
              }

              if (thisValue && isDate) {
                thisValue = Date.parse(thisValue.toString());
              }

              if (compareValue && $(`#${comparedWithDomId}`).hasClass('date-field')) {
                compareValue = Date.parse(compareValue.toString());
              }

              if (thisValue && compareValue) {
                let display = isTime || isDate ? $(`#${comparedWithDomId}`).val() : compareValue;
                switch (operation) {
                  case 'mustBeGreater':
                    if (!(thisValue > compareValue)) {
                      returnObj.message += ` ${thisName} must be greater than ${display}`;
                      returnObj.isValid = false;
                    }
                    break;
                  case 'mustBeLess':
                    if (!(thisValue < compareValue)) {
                      returnObj.message += ` ${thisName} must be less than ${display}`;
                      returnObj.isValid = false;
                    }
                    break;
                  case 'mustBeEqual':
                    if (!(thisValue === compareValue)) {
                      returnObj.message += ` ${thisName} must equal to ${display}`;
                      returnObj.isValid = false;
                    }
                    break;
                  case 'mustNotBeEqual':
                    if (!(thisValue !== compareValue)) {
                      returnObj.message += ` ${thisName} must not equal to ${display}`;
                      returnObj.isValid = false;
                    }
                    break;
                }
              }
            }
          });
        }
      });
    }

    return returnObj;
  };

  function addressCheck(field) {
    var result = { err: false };
    if (field.required && field.logic && field.logic.length > 0) {
      for (var i = 0; i < field.logic.length; i++) {
        var logic = field.logic[i];
        if (
          logic.idOverride !== undefined &&
          logic.idOverride !== '' &&
          document.getElementById(logic.idOverride).value === ''
        ) {
          var el = document.getElementById(logic.idOverride);
          result = {
            err: true,
            el,
            labelText: el.parentNode.getElementsByClassName('input-group-addon')[0].innerText,
          };
          break;
        }
      }
    }

    return result;
  }

  function feePayoffCheck(field) {
    const retVal = { err: false };
    const labelText = field.properties.label;
    // We need the payments reload to do this validation.. if not available, assume we are not entering a payment and validation is not necessary
    if (app.ui.controls.payments.getActiveReload()) {
      const markedFees = app.ui.controls.payments.getActiveReload().entryV.data[field.properties.id];
      const noFeesSelected = markedFees == '' || markedFees == '[]';
      if (app.misc.isValueTrue(field.required) && noFeesSelected) {
        retVal.err = true;
        retVal.labelText = labelText;
        return retVal;
      }
      if (noFeesSelected) {
        const continueWithNoFees = confirm(
          'You have not applied this Payment to any Invoice or Fees.  Are you sure you want to continue?'
        );

        if (!continueWithNoFees) {
          retVal.err = true;
          retVal.labelText = labelText;
          return retVal;
        }
      }
    }

    return retVal;
  }

  var check = function (saveArgs, elID, formFields, data) {
    // Serialize form object
    var frmObj =
      data ||
      $(elID).serializeFields({
        type: 'JSON',
        encode: false,
      });
    var finalSave = 'no';
    var key;

    var metaMap = {};
    formFields.forEach((itm, idx) => {
      metaMap[itm.properties.id || new Date().getTime().toString()] = idx;
    });

    // Allow custom values to be passed in at any interval
    if (saveArgs) {
      for (key in saveArgs) {
        frmObj[key] = saveArgs[key];
        // Mark this as a "final" save and change the alert appropriately
        if (
          (key === 'autoSaved' && saveArgs[key] === 0) ||
          (key === 'finalSave' && saveArgs[key].toLowerCase() === 'yes')
        ) {
          finalSave = 'yes';
        }
      }
    }
    var validator;
    // Check required fields
    for (var i = 0, len = formFields.length; i < len; i++) {
      var _f = formFields[i];
      var fld = elID ? $(`${elID} #${_f.properties.id}`) : $(`#${_f.properties.id}`);
      /*
        NOTE:
            The validator name is matched to the data attribute on the tag then immediately executed. If not found, the validator is just null. Each validator should return an object with:
                raw (the raw non-formatted value)
                formatted (the formatted value, if applicable)
                isValid (is it a valid value for this type)
                message (the custom alert message)
            - sg 02/26/2016
      */
     try {
      validator = (
        {
          phone(value) {
            var rawValue = (value || '').toString().replace(/\D/gi, '');

            /*
              NOTE: These phone validation/formatters come from me.core.js as String.prototypes
            */
            return {
              raw: rawValue,
              formatted: rawValue.parsePhone(),
              message: 'Please enter a valid phone number',
              alwaysEnforceValidation: true,
              isValid: rawValue.isPhone() || rawValue === '',
            };
          },
          email(value) {
            var rawValue = (value || '').toString().trim();
            return {
              raw: rawValue,
              formatted: rawValue,
              message: 'Please enter a valid email address',
              alwaysEnforceValidation: true,
              isValid: rawValue.isEmail() || rawValue === '',
            };
          },
          mustBeGreater: (value) => validationFunc(value, fld, 'mustBeGreater', _f.logic),
          mustBeLess: (value) => validationFunc(value, fld, 'mustBeLess', _f.logic),
          mustBeEqual: (value) => validationFunc(value, fld, 'mustBeEqual', _f.logic),
          mustNotBeEqual: (value) => validationFunc(value, fld, 'mustNotBeEqual', _f.logic),
          preventFutureDates(value) {
            var rawValue = value;
            var mom = moment(rawValue);

            return {
              raw: rawValue,
              formatted: mom.format(app.config.system.dateFormat.toUpperCase()),
              message: 'You cannot enter a future date',
              alwaysEnforceValidation: true,
              isValid: rawValue.trim() === '' || !mom.isAfter(moment()),
            };
          },
          password(value) {
            var message = ['{label} must contain at least'.assign(_f.properties)];
            var isValid = true;
            var rawValue = '';

            if (fld.css('display') !== 'none') {
              rawValue = value;
              if (fld.hasClass('badPass')) {
                if (fld.hasClass('specialCharactersReq')) {
                  message.push(' 1 special character');
                  isValid = false;
                }
                if (fld.hasClass('capitalsReq')) {
                  message.push(' 1 capital letter');
                  isValid = false;
                }
                if (fld.hasClass('numbersReq')) {
                  message.push(' 1 number');
                  isValid = false;
                }
                if (fld.hasClass('minLengthReq')) {
                  message.push(' {minLength} characters'.assign(app.config.system.passwordSettings));
                  isValid = false;
                }
              }
            }

            return {
              raw: rawValue,
              formatted: value,
              message: message.join(''),
              isValid,
            };
          },
          date(value) {
            var message = "";
            var isValid = true;
            var rawValue = value;

            if (value !== "" && !Date.parse(value)) {
              message = "Please enter a valid date.";
              isValid = false;
            }

            return {
              raw: rawValue,
              formatted: value,
              message,
              alwaysEnforceValidation: true,
              isValid,
            };
          },
        }[formFields[metaMap[_f.properties.id]].type.replace("-field","") || ''] ||
        function (value) {
          return {
            raw: value,
            formatted: value,
            isValid: true,
            message: null,
          };
        }
      )(frmObj[_f.properties.id]);
     }
     catch(err) {
      console.log("validation error");
      console.log(err);
     }
      

      /*
        NOTE:
            The alwaysEnforceValidation means the validation will still fire even if the field is not required.  This will prevent submission in cases where it's non-required field but the validation still needs to be enforced
            - sg 07/10/2019
      */
      var isRequired = _f.required == 'true' || _f.required == true;
      var enforceValidation = validator.alwaysEnforceValidation ? validator.alwaysEnforceValidation : false;
      var allowAbleField = !['spacer','infobox'].includes(_f.type);
      var isVisible =
        fld.is(':visible') ||
        _f.visibilityOverride ||
        (['signature', 'checkbox', 'formSearch', 'date', 'time'].includes(_f.type) &&
          ($(`#container-${_f.properties.id}`).is(':visible') || $(`#srch-${_f.properties.id}`).is(':visible')));
      var currentKey;
      if (formFields[i].properties.id.endsWith('-v')) {
        currentKey = formFields[i].properties.id.substring(0, formFields[i].properties.id.length - 2);
      } else {
        currentKey = formFields[i].properties.id;
      }
      

      try {
        if (fld[0].disabled) {
          isVisible = false;
        }
      } catch (e) {}

      var bail = false;

      var addrRes = { err: false };

      if (_f.type === 'address-control') {
        addrRes = addressCheck(_f);
      }

      var feePayoffRes = { err: false };
      if (_f.type === 'feePayoffSelector') {
        feePayoffRes = feePayoffCheck(_f);
      }

      if (_f.logic && Array.isArray(_f.logic)) {
        _f.logic.forEach((logic) => {
          if (logic.type === 'constrainByOtherField') {
            if (
              !app.ui.logic.constrainByOtherField({ args: _f }, logic, formFields, metaMap, {
                newValue: document.getElementById(_f.properties.id).value,
              })
            ) {
              bail = true;
              validator.isValid = false;
            }
          }
        });
      }

      if (bail) {
        return validator;
      }

      if (!isVisible && fld.parent().is(':visible') && app.misc.isValueTrue(_f.properties.useTypeAhead)) {
        isVisible = true;
      }

      if (
        (isRequired || enforceValidation) &&
        allowAbleField &&
        isVisible &&
        ((_f.type !== 'reload' &&
          (frmObj[_f.properties.id] === '' ||
            frmObj[_f.properties.id] === null ||
            frmObj[_f.properties.id] === undefined) &&
          isRequired) ||
          validator.isValid === false ||
          (fld[0].value === '' && isRequired && ['reload'].indexOf(_f.type) === -1) ||
          (_f.type == 'checkbox' && frmObj[_f.properties.id] === '[]' && isRequired) ||
          (_f.type == 'reload' &&
            (frmObj[`${_f.properties.id}_values`] === '[]' ||
              (Array.isArray(frmObj[`${_f.properties.id}_values`]) &&
                frmObj[`${_f.properties.id}_values`].length === 0)) &&
            isRequired))
      ) {
        if (finalSave === 'yes') {
          alert(!validator.isValid && validator.message ? validator.message : '{label} is required'.assign(_f.properties));
          fld.focus();
        }
        if (!this.isDraft) {
          console.log("Couldn't save due to missing required fields");
          return {
            validator: validator,
            passed: false
          };
        }
      } else if (addrRes.err) {
        validator.isValid = false;
        if (finalSave === 'yes') {
          alert(!validator.isValid && validator.message ? validator.message : '{labelText} is required'.assign(addrRes));
          addrRes.el.focus();
        }
        if (!this.isDraft) {
          console.log("Couldn't save due to missing required fields");
          return validator;
        }
      } else {
        /*
            NOTE:
                Only send the raw value to the database
                - sg 02/26/2016
        */
        frmObj[_f.properties.id] = validator.raw;
        /*
            NOTE:
                If this isn't required, yet it's invalid because it's blank, set
                the isValid back to true so we don't trigger a false positive.
        */
        if (_f.required !== true && validator.raw === '') {
          validator.isValid = true;
        }
      }
    }

    /*
        NOTE:
            Return the data too since we sometimes strip out some stuff on validation
    */
    validator.data = frmObj;

    return {
      validator: validator,
      passed: true
    };
  };
  // confirm('click this stuff');
  return check;
});
